import Repository from '@/api/Repository'

const resource = '/group'

export default {
  index(data) {
    return Repository.get(resource, {
      data,
    })
  },
  indexSystem() {
    return Repository.get(`${resource}?type=system`)
  },
  show(id) {
    return Repository.get(`${resource}/${id}`)
  },
  update(id, data) {
    return Repository.put(`${resource}/${id}`, data)
  },
  create(data) {
    return Repository.post(resource, data)
  },
  delete(id) {
    return Repository.delete(`${resource}/${id}`)
  },
  updateUserGroup(user_id, group_id) {
    return Repository.post(`${resource}/update-user-group`, {
      userId: user_id,
      groupId: group_id,
    })
  },
}
